export const HANDLE_SOCKET = 'messages/HANDLE_SOCKET';

export const PENDING_MESSAGE = 'messages/PENDING_MESSAGE';
export const ADD_MESSAGE = 'messages/ADD_MESSAGE';
